
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1 12C1 5.925 5.925 1 12 1s11 4.925 11 11-4.925 11-11 11S1 18.075 1 12zm11-5.867c-1.593 0-1.793.007-2.418.036-.625.028-1.051.127-1.424.272-.386.15-.714.35-1.04.677a2.88 2.88 0 00-.677 1.039c-.145.373-.244.8-.272 1.424-.028.626-.036.826-.036 2.42 0 1.592.007 1.792.036 2.417.029.625.127 1.051.272 1.424.15.386.35.714.677 1.04.326.326.653.527 1.039.677.373.145.8.244 1.424.272.626.029.826.036 2.419.036s1.793-.007 2.418-.036c.625-.028 1.052-.127 1.425-.272a2.87 2.87 0 001.039-.677 2.88 2.88 0 00.677-1.04c.144-.373.243-.8.272-1.423.028-.626.036-.826.036-2.419s-.008-1.793-.036-2.419c-.03-.625-.128-1.05-.272-1.424a2.88 2.88 0 00-.677-1.04 2.867 2.867 0 00-1.04-.676c-.373-.145-.8-.244-1.424-.272-.626-.029-.825-.036-2.42-.036h.003zm-.526 1.058h.527c1.566 0 1.752.005 2.37.033.572.026.883.122 1.09.202.273.107.468.234.674.44.205.204.332.4.439.674.08.206.176.517.202 1.089.028.618.034.804.034 2.37 0 1.565-.006 1.751-.034 2.37-.026.572-.122.882-.202 1.089a1.814 1.814 0 01-.44.674c-.205.205-.4.332-.674.438-.206.081-.517.176-1.089.203-.618.028-.804.034-2.37.034-1.567 0-1.753-.006-2.371-.034-.572-.027-.883-.122-1.09-.203a1.817 1.817 0 01-.674-.439 1.818 1.818 0 01-.44-.674c-.08-.206-.175-.517-.201-1.089-.028-.618-.034-.804-.034-2.37 0-1.567.006-1.752.034-2.37.026-.573.122-.883.202-1.09.106-.274.234-.47.439-.675.205-.205.4-.332.675-.439.206-.08.517-.176 1.089-.202.541-.024.75-.032 1.844-.033v.002zm3.658.974a.704.704 0 100 1.408.704.704 0 000-1.409zm-3.131.822a3.013 3.013 0 100 6.026 3.013 3.013 0 000-6.026zm0 1.057a1.956 1.956 0 110 3.912 1.956 1.956 0 010-3.912z","fill":"currentColor","fill-rule":"evenodd"}})])
          )
        }
      }
    